module.exports = __webpack_public_path__ + "static/assets/93259f95026260bc06f83d29d3b89115.svg";